<template>
  <v-form ref="form" class="form">
    <v-row>
      <v-col class="py-0" cols="12">
        <v-text-field
          v-model="source.type"
          :label="$t('sources.type')"
          readonly
          :loading="resourceLoading"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-text-field
          v-model="source.authentication"
          :label="$t('sources.authentication')"
          readonly
          :loading="resourceLoading"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-text-field
          v-model="source.name"
          :label="$t('sources.name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [rules.required, backEndValidation('name')]
          "
          :readonly="readonly"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-textarea
          v-model="source.notices"
          :label="$t('sources.notices')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('notices')]"
          :readonly="readonly"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-btn
      color="primary mr-3"
      v-on:click="save()"
      :loading="loading"
      :disabled="readonly"
    >
      <v-icon left>{{ $props.button_icon }}</v-icon>
      {{ $t(`documents.${$props.button_title}`) }}
    </v-btn>
  </v-form>
</template>

<script>
import { rules } from "../../../mixins/rules";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";

export default {
  name: "FormSource",
  mixins: [rules, projectPermissions],
  data: () => ({
    loading: false
  }),
  props: {
    dispatch: String,
    button_title: String,
    button_icon: String,
    source: {
      default: function() {
        return {};
      }
    },
    resourceLoading: {
      type: Boolean,
      default: false
    },
    permission: {
      type: String,
      default: ""
    }
  },
  computed: {
    readonly: {
      get() {
        return !this.hasCurrentProjectPermissions(this.permission);
      }
    }
  },
  methods: {
    save() {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        let item = {
          id: this.source.id,
          name: this.source.name,
          notices: this.source.notices,
          project_id: this.source.project_id
        };
        this.$store
          .dispatch(this.$props.dispatch, {
            item,
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            })
          })
          .finally(() => (this.loading = false));
      }
    }
  }
};
</script>
